module.exports = __webpack_public_path__ + "img/Speaker=Rahul Rana.14c8f9bc.png";